import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from 'moment';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmationText from './components/ConfirmationText/ConfirmationText';
import ChangePassword from './components/Modals/ChangePassword/ChangePassword';
import ConfirmModal from './components/Modals/ConfirmModal/ConfirmModal';
import ForgottenPassword from './components/Modals/ForgottenPassword/ForgottenPassword';
import RecoveryPassword from './components/Modals/RecoveryPassword/RecoveryPassword';
import WalletModal from './components/Modals/WalletModal/WalletModal';
import { Routes } from './constants/routes';
import { useStableRoutes } from './hooks/stable';
import useResponsive from './hooks/useResponsive';
import DefaultLayout from './layouts/DefaultLayout';
import { useAppDispatch, useAppSelector } from './store/reducers';
import { resetStatus } from './store/reducers/ChangePassword/changePasswordSlice';
import { setStyle } from './store/reducers/IFrame/iFrameSlice';
import { setChangePasswordModal, setConfirmChangePasswordModal, setConfirmCreatedAccountModal, setConfirmPasswordFailedModal, setConfirmPasswordModal, setFailedAccountModal, setLinkSendModal, setStableDetails, setWalletModal } from './store/reducers/ModalsState/slice';
import { clearError } from './store/reducers/PasswordRecovery/passwordRecoverySlice';
import { clearData } from './store/reducers/SignUp/signupSlice';
import AppRouter from './system/AppRouter';
const App = ({ canNavigate }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { changePasswordModal, forgotPasswordModal, confirmChangePasswordModal, confirmCreatedAccount, confirmForgotPassword, confirmFailedPassword, linkSend, walletModal, recoveryPassword, confirmFailedAccount } = useAppSelector((state) => state.modal);
    const { loggedIn, notMatchStakeId } = useAppSelector((state) => state.auth);
    const { emailConfirmed, error } = useAppSelector((state) => state.signup);
    const { stableNameDetails } = useAppSelector((state) => state.modal);
    const isResponsive = useResponsive('xl');
    const { pathname } = useLocation();
    const { listRoute, stableRoute, horsesListRoute, jockeysListRoute, configuratorRoute, horseRoute, jockeyRoute } = useStableRoutes();
    useEffect(() => {
        if (emailConfirmed === true) {
            dispatch(setConfirmCreatedAccountModal(true));
            dispatch(clearData());
        }
        else if (emailConfirmed === false) {
            dispatch(setFailedAccountModal(true));
            dispatch(clearData());
        }
    }, [dispatch, navigate, emailConfirmed, error]);
    //Horse or Jockey view
    const isHorseOrJockeyRoute = useMemo(() => {
        return (pathname.includes(horseRoute) ||
            pathname.includes(jockeyRoute) ||
            (pathname.includes('stake') && !pathname.includes('list')));
    }, [pathname, horseRoute, jockeyRoute]);
    //Visible Routes for 3D Scene
    const SCENE_VISIBLE_ROUTES = useMemo(() => [Routes.STABLES, Routes.CONFIGURATOR], []);
    useEffect(() => {
        const isVisible = loggedIn &&
            !notMatchStakeId &&
            (SCENE_VISIBLE_ROUTES.find((el) => pathname === el) || isHorseOrJockeyRoute);
        const iFrameStyle = {
            display: loggedIn && isVisible ? 'block' : 'none',
            zIndex: isVisible ? 'unset' : -2
        };
        dispatch(setStyle(iFrameStyle));
    }, [pathname]);
    useEffect(() => {
        moment.locale(navigator.language);
    }, []);
    return (_jsxs(DefaultLayout, { children: [stableNameDetails && loggedIn && !isResponsive && (_jsx(ConfirmationText, { isClosed: stableNameDetails, closeModal: () => dispatch(setStableDetails(false)), text: `${t('changes_have_been_saved')}!` })), _jsx(AppRouter, { canNavigate: canNavigate }), walletModal && (_jsx(WalletModal, { onClose: () => dispatch(setWalletModal(false)), updateWalletsOnMount: true })), changePasswordModal && (_jsx(ChangePassword, { onClick: () => {
                    dispatch(setChangePasswordModal(false));
                    dispatch(resetStatus());
                } })), forgotPasswordModal && _jsx(ForgottenPassword, {}), recoveryPassword && _jsx(RecoveryPassword, {}), confirmChangePasswordModal && (_jsx(ConfirmModal, { onClick: () => dispatch(setConfirmChangePasswordModal(false)), text: t('password_changed') })), confirmCreatedAccount === true && (_jsx(ConfirmModal, { onClick: () => {
                    dispatch(setConfirmCreatedAccountModal(false));
                }, text: `${t('account_created')}!` })), confirmFailedAccount && (_jsx(ConfirmModal, { onClick: () => dispatch(setFailedAccountModal(false)), text: `${t('account_failed')}!` })), confirmForgotPassword && (_jsx(ConfirmModal, { onClick: () => dispatch(setConfirmPasswordModal(false)), text: `${t('password_changed')}!` })), confirmFailedPassword && (_jsx(ConfirmModal, { onClick: () => dispatch(setConfirmPasswordFailedModal(false)), text: t('password_failed') })), linkSend && (_jsx(ConfirmModal, { onClick: () => {
                    dispatch(setLinkSendModal(false));
                    dispatch(clearError());
                }, text: `${t('link_already_sent')}!` }))] }));
};
export default App;
